import { axiosInstance } from "~/plugins/axios";

export function addAds(data: any) {
  return axiosInstance.post("/lead-ads", data);
}